import { cn } from '@/utils/cn.ts';

import type { ChatAction } from '../../../../../bridge/types/messages.ts';

export const ChatActions = ({
	actions,
	onAction,
}: {
	actions: ChatAction[];
	onAction: (action: ChatAction) => void;
}) => {
	return (
		<div className="mt-3 flex flex-wrap gap-2">
			{actions.map((action) => (
				<button
					key={action.id}
					onClick={() => onAction(action)}
					className={cn(
						'rounded-lg px-4 py-2 text-sm font-semibold transition-colors',
						action.style === 'secondary'
							? `border border-white/20 bg-white/5 text-white/80
								hover:bg-white/10`
							: 'bg-beacon-accent hover:bg-beacon-accent-hover text-white',
					)}
				>
					{action.label}
				</button>
			))}
		</div>
	);
};
